var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"z-index":"100"},attrs:{"fab":"","fixed":"","bottom":"","right":"","dark":"","color":"techBlue"},on:{"click":_vm.switchFullScreen}},[_c('v-icon',[_vm._v(_vm._s(_vm.isFullScreen ? "mdi-fullscreen-exit" : "mdi-fullscreen"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }